import { responsiveStyle } from '../responsive/responsive-style.ts';
import { space } from '../tokens.ts';
import { style, styleVariants } from '../layer.css';

export const selectionTagGroup = style({
  display: 'flex',
  alignItems: 'center',
});

export const selectionTagGroupSize = styleVariants({
  sm: [
    responsiveStyle({
      mobile: { gap: space.s4 },
      tablet: { gap: space.s8 },
    }),
  ],
  md: [
    responsiveStyle({
      mobile: { gap: space.s8 },
      tablet: { gap: space.s16 },
    }),
  ],
});
